export default __webpack_public_path__ + "static/media/background.345f7c12.jpg";